import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const TableLink = styled(NavLink)`
  font-weight: ${({ theme }) => theme.font.weights.normal};
`;

export default TableLink;
